import { render, staticRenderFns } from "./MiniAppTheme.vue?vue&type=template&id=380c9c00&scoped=true"
import script from "./MiniAppTheme.vue?vue&type=script&lang=js"
export * from "./MiniAppTheme.vue?vue&type=script&lang=js"
import style0 from "./MiniAppTheme.vue?vue&type=style&index=0&id=380c9c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c9c00",
  null
  
)

export default component.exports